export const environment = {
	appName: 'Reframe',
	home: '/painel/calculadora/start',
	production: true,
	cognito: {
		region: 'us-east-1',
		ClientId: '292qk33mj3i1sj248gk668tqu9',
		UserPoolId: 'us-east-1_U438Q5Yj9'
	},
	api: 'https://api.reframe.com.br/api/1.0',
	url: 'https://reframe.com.br',
	apiViaCepUrl: 'https://viacep.com.br/ws/',
	apiCnpjSearch: 'https://brasilapi.com.br/api/cnpj/v1/',
	passwordRules: {
		minlength: 6,
		minLowercaseCharacterRule: 1,
		minUppercaseCharacterRule: 1,
		minDigitCharacterRule: 1,
		minSpecialCharacterRule: 1
	},

	iugu_id: '649DB57CD866443A8E3F4625DFC3187D',

	title: 'Reframe',
	description: ``,
	image: '',
	keywords: '',
	loggerEnabled: false,
};
